export const erc20Abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "allowance",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "needed",
        type: "uint256",
      },
    ],
    name: "ERC20InsufficientAllowance",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "needed",
        type: "uint256",
      },
    ],
    name: "ERC20InsufficientBalance",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "approver",
        type: "address",
      },
    ],
    name: "ERC20InvalidApprover",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
    ],
    name: "ERC20InvalidReceiver",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "ERC20InvalidSender",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "ERC20InvalidSpender",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export const merchantRegistryAbi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "AddressEmptyCode",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "ERC1967InvalidImplementation",
    type: "error",
  },
  {
    inputs: [],
    name: "ERC1967NonPayable",
    type: "error",
  },
  {
    inputs: [],
    name: "FailedInnerCall",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidInitialization",
    type: "error",
  },
  {
    inputs: [],
    name: "NotInitializing",
    type: "error",
  },
  {
    inputs: [],
    name: "UUPSUnauthorizedCallContext",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "slot",
        type: "bytes32",
      },
    ],
    name: "UUPSUnsupportedProxiableUUID",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "merchant",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isBlacklist",
        type: "bool",
      },
    ],
    name: "BlacklistMerchant",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "version",
        type: "uint64",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "merchant",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "minStake",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "leverage",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "redactedAccNum",
            type: "uint256",
          },
          {
            internalType: "string",
            name: "telegramId",
            type: "string",
          },
          {
            internalType: "enum MerchantRegistry.MerchantTier",
            name: "tier",
            type: "uint8",
          },
          {
            internalType: "enum MerchantRegistry.RiskCategory",
            name: "riskCategory",
            type: "uint8",
          },
        ],
        indexed: false,
        internalType: "struct MerchantRegistry.MerchantConfig",
        name: "merchantConfig",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "stake",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isOnline",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isApproved",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isRegistered",
            type: "bool",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "usdt",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "fiat",
                type: "uint256",
              },
            ],
            internalType: "struct MerchantRegistry.FreeAmount",
            name: "freeAmount",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "totalVolume",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "withdrawnAmount",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct MerchantRegistry.MerchantDetails",
        name: "merchantDetails",
        type: "tuple",
      },
    ],
    name: "Merchant",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "merchant",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "minStake",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "leverage",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "redactedAccNum",
            type: "uint256",
          },
          {
            internalType: "string",
            name: "telegramId",
            type: "string",
          },
          {
            internalType: "enum MerchantRegistry.MerchantTier",
            name: "tier",
            type: "uint8",
          },
          {
            internalType: "enum MerchantRegistry.RiskCategory",
            name: "riskCategory",
            type: "uint8",
          },
        ],
        indexed: false,
        internalType: "struct MerchantRegistry.MerchantConfig",
        name: "merchantConfig",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "stake",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isOnline",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isApproved",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isRegistered",
            type: "bool",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "usdt",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "fiat",
                type: "uint256",
              },
            ],
            internalType: "struct MerchantRegistry.FreeAmount",
            name: "freeAmount",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "totalVolume",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "withdrawnAmount",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct MerchantRegistry.MerchantDetails",
        name: "merchantDetails",
        type: "tuple",
      },
    ],
    name: "MerchantApproved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "merchant",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "minStake",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "leverage",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "redactedAccNum",
            type: "uint256",
          },
          {
            internalType: "string",
            name: "telegramId",
            type: "string",
          },
          {
            internalType: "enum MerchantRegistry.MerchantTier",
            name: "tier",
            type: "uint8",
          },
          {
            internalType: "enum MerchantRegistry.RiskCategory",
            name: "riskCategory",
            type: "uint8",
          },
        ],
        indexed: false,
        internalType: "struct MerchantRegistry.MerchantConfig",
        name: "merchantConfig",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "stake",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isOnline",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isApproved",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isRegistered",
            type: "bool",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "usdt",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "fiat",
                type: "uint256",
              },
            ],
            internalType: "struct MerchantRegistry.FreeAmount",
            name: "freeAmount",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "totalVolume",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "withdrawnAmount",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct MerchantRegistry.MerchantDetails",
        name: "merchantDetails",
        type: "tuple",
      },
    ],
    name: "MerchantStaked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "merchant",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isOnline",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "minStake",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "leverage",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "redactedAccNum",
            type: "uint256",
          },
          {
            internalType: "string",
            name: "telegramId",
            type: "string",
          },
          {
            internalType: "enum MerchantRegistry.MerchantTier",
            name: "tier",
            type: "uint8",
          },
          {
            internalType: "enum MerchantRegistry.RiskCategory",
            name: "riskCategory",
            type: "uint8",
          },
        ],
        indexed: false,
        internalType: "struct MerchantRegistry.MerchantConfig",
        name: "merchantConfig",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "stake",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isOnline",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isApproved",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isRegistered",
            type: "bool",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "usdt",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "fiat",
                type: "uint256",
              },
            ],
            internalType: "struct MerchantRegistry.FreeAmount",
            name: "freeAmount",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "totalVolume",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "withdrawnAmount",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct MerchantRegistry.MerchantDetails",
        name: "merchantDetails",
        type: "tuple",
      },
    ],
    name: "OnlineOfflineToggled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "merchant",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "minStake",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "leverage",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "redactedAccNum",
            type: "uint256",
          },
          {
            internalType: "string",
            name: "telegramId",
            type: "string",
          },
          {
            internalType: "enum MerchantRegistry.MerchantTier",
            name: "tier",
            type: "uint8",
          },
          {
            internalType: "enum MerchantRegistry.RiskCategory",
            name: "riskCategory",
            type: "uint8",
          },
        ],
        indexed: false,
        internalType: "struct MerchantRegistry.MerchantConfig",
        name: "merchantConfig",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "stake",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isOnline",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isApproved",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isRegistered",
            type: "bool",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "usdt",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "fiat",
                type: "uint256",
              },
            ],
            internalType: "struct MerchantRegistry.FreeAmount",
            name: "freeAmount",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "totalVolume",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "withdrawnAmount",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct MerchantRegistry.MerchantDetails",
        name: "merchantDetails",
        type: "tuple",
      },
    ],
    name: "UnstakeApproved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "merchant",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "minStake",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "leverage",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "redactedAccNum",
            type: "uint256",
          },
          {
            internalType: "string",
            name: "telegramId",
            type: "string",
          },
          {
            internalType: "enum MerchantRegistry.MerchantTier",
            name: "tier",
            type: "uint8",
          },
          {
            internalType: "enum MerchantRegistry.RiskCategory",
            name: "riskCategory",
            type: "uint8",
          },
        ],
        indexed: false,
        internalType: "struct MerchantRegistry.MerchantConfig",
        name: "merchantConfig",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "stake",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isOnline",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isApproved",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isRegistered",
            type: "bool",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "usdt",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "fiat",
                type: "uint256",
              },
            ],
            internalType: "struct MerchantRegistry.FreeAmount",
            name: "freeAmount",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "totalVolume",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "withdrawnAmount",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct MerchantRegistry.MerchantDetails",
        name: "merchantDetails",
        type: "tuple",
      },
    ],
    name: "UnstakeRequested",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    inputs: [],
    name: "UPGRADE_INTERFACE_VERSION",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "merchant",
        type: "address",
      },
    ],
    name: "amountForUnstake",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "merchant",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "minStake",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "leverage",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "redactedAccNum",
            type: "uint256",
          },
          {
            internalType: "string",
            name: "telegramId",
            type: "string",
          },
          {
            internalType: "enum MerchantRegistry.MerchantTier",
            name: "tier",
            type: "uint8",
          },
          {
            internalType: "enum MerchantRegistry.RiskCategory",
            name: "riskCategory",
            type: "uint8",
          },
        ],
        internalType: "struct MerchantRegistry.MerchantConfig",
        name: "_merchantConfig",
        type: "tuple",
      },
    ],
    name: "approveOrUpdateMerchant",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "merchant",
        type: "address",
      },
    ],
    name: "approveUnstake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_usdtAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_fiatAmount",
        type: "uint256",
      },
      {
        internalType: "int256",
        name: "orderType",
        type: "int256",
      },
      {
        internalType: "uint256",
        name: "userOrderCount",
        type: "uint256",
      },
    ],
    name: "assignMerchants",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_merchant",
        type: "address",
      },
    ],
    name: "blacklistMerchant",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "blacklistedMerchants",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "merchant",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_usdtAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_fiatAmount",
        type: "uint256",
      },
    ],
    name: "blockFreeAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "merchant",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_volume",
        type: "uint256",
      },
    ],
    name: "blockVolumeHook",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "currency",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "disputedMerchants",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "eligibleMerchants",
    outputs: [
      {
        internalType: "address",
        name: "merchant",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "lastUsedTimestamp",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "exchangeConfig",
    outputs: [
      {
        internalType: "contract IP2pxConfig",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "merchant",
        type: "address",
      },
    ],
    name: "feeAccrued",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_merchant",
        type: "address",
      },
    ],
    name: "getMerchantConfig",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "minStake",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "leverage",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "redactedAccNum",
            type: "uint256",
          },
          {
            internalType: "string",
            name: "telegramId",
            type: "string",
          },
          {
            internalType: "enum MerchantRegistry.MerchantTier",
            name: "tier",
            type: "uint8",
          },
          {
            internalType: "enum MerchantRegistry.RiskCategory",
            name: "riskCategory",
            type: "uint8",
          },
        ],
        internalType: "struct MerchantRegistry.MerchantConfig",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_usdt",
        type: "address",
      },
      {
        internalType: "address",
        name: "_exchangeConfig",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "merchantConfig",
    outputs: [
      {
        internalType: "uint256",
        name: "minStake",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "leverage",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "redactedAccNum",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "telegramId",
        type: "string",
      },
      {
        internalType: "enum MerchantRegistry.MerchantTier",
        name: "tier",
        type: "uint8",
      },
      {
        internalType: "enum MerchantRegistry.RiskCategory",
        name: "riskCategory",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "merchantDetails",
    outputs: [
      {
        internalType: "uint256",
        name: "stake",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "isOnline",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "isApproved",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "isRegistered",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "usdt",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fiat",
            type: "uint256",
          },
        ],
        internalType: "struct MerchantRegistry.FreeAmount",
        name: "freeAmount",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "totalVolume",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "withdrawnAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "merchant",
        type: "address",
      },
      {
        internalType: "bool",
        name: "isDisputed",
        type: "bool",
      },
    ],
    name: "merchantDisputed",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "merchantFeePer",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "merchant",
        type: "address",
      },
      {
        internalType: "bool",
        name: "isOngoing",
        type: "bool",
      },
    ],
    name: "merchantOngoingOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "ongoingOrderMerchants",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "orderProcessor",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "register",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "merchant",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_usdtAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_fiatAmount",
        type: "uint256",
      },
    ],
    name: "releaseFreeAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "merchant",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_volume",
        type: "uint256",
      },
    ],
    name: "releaseVolumeHook",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_merchant",
        type: "address",
      },
    ],
    name: "removeBlacklist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "requestUnstake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_orderProcessor",
        type: "address",
      },
    ],
    name: "setOrderProcessor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "stake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_merchant",
        type: "address",
      },
    ],
    name: "toggleOnlineOffline",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "totalStake",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "unstakeRequested",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "usdt",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export const orderProcessorAbi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "AddressEmptyCode",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "ERC1967InvalidImplementation",
    type: "error",
  },
  {
    inputs: [],
    name: "ERC1967NonPayable",
    type: "error",
  },
  {
    inputs: [],
    name: "FailedInnerCall",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidInitialization",
    type: "error",
  },
  {
    inputs: [],
    name: "NotInitializing",
    type: "error",
  },
  {
    inputs: [],
    name: "UUPSUnauthorizedCallContext",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "slot",
        type: "bytes32",
      },
    ],
    name: "UUPSUnsupportedProxiableUUID",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fiatAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "placedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "completedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "userCompletedTimestamp",
            type: "uint256",
          },
          {
            internalType: "address[]",
            name: "assignedMerchants",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "acceptedMerchant",
            type: "address",
          },
          {
            internalType: "address",
            name: "user",
            type: "address",
          },
          {
            internalType: "address",
            name: "recipientAddr",
            type: "address",
          },
          {
            internalType: "string",
            name: "pubkey",
            type: "string",
          },
          {
            internalType: "string",
            name: "encUpi",
            type: "string",
          },
          {
            internalType: "bool",
            name: "userCompleted",
            type: "bool",
          },
          {
            internalType: "enum OrderProcessor.OrderStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "enum OrderProcessor.OrderType",
            name: "orderType",
            type: "uint8",
          },
          {
            components: [
              {
                internalType: "enum OrderProcessor.Entity",
                name: "raisedBy",
                type: "uint8",
              },
              {
                internalType: "enum OrderProcessor.DisputeStatus",
                name: "status",
                type: "uint8",
              },
              {
                internalType: "uint256",
                name: "redactTransId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "accountNumber",
                type: "uint256",
              },
            ],
            internalType: "struct OrderProcessor.Dispute",
            name: "disputeInfo",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct OrderProcessor.Order",
        name: "_order",
        type: "tuple",
      },
    ],
    name: "BuyOrderPaid",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fiatAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "placedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "completedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "userCompletedTimestamp",
            type: "uint256",
          },
          {
            internalType: "address[]",
            name: "assignedMerchants",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "acceptedMerchant",
            type: "address",
          },
          {
            internalType: "address",
            name: "user",
            type: "address",
          },
          {
            internalType: "address",
            name: "recipientAddr",
            type: "address",
          },
          {
            internalType: "string",
            name: "pubkey",
            type: "string",
          },
          {
            internalType: "string",
            name: "encUpi",
            type: "string",
          },
          {
            internalType: "bool",
            name: "userCompleted",
            type: "bool",
          },
          {
            internalType: "enum OrderProcessor.OrderStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "enum OrderProcessor.OrderType",
            name: "orderType",
            type: "uint8",
          },
          {
            components: [
              {
                internalType: "enum OrderProcessor.Entity",
                name: "raisedBy",
                type: "uint8",
              },
              {
                internalType: "enum OrderProcessor.DisputeStatus",
                name: "status",
                type: "uint8",
              },
              {
                internalType: "uint256",
                name: "redactTransId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "accountNumber",
                type: "uint256",
              },
            ],
            internalType: "struct OrderProcessor.Dispute",
            name: "disputeInfo",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct OrderProcessor.Order",
        name: "_order",
        type: "tuple",
      },
    ],
    name: "CancelledOrders",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "by",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fiatAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "placedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "completedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "userCompletedTimestamp",
            type: "uint256",
          },
          {
            internalType: "address[]",
            name: "assignedMerchants",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "acceptedMerchant",
            type: "address",
          },
          {
            internalType: "address",
            name: "user",
            type: "address",
          },
          {
            internalType: "address",
            name: "recipientAddr",
            type: "address",
          },
          {
            internalType: "string",
            name: "pubkey",
            type: "string",
          },
          {
            internalType: "string",
            name: "encUpi",
            type: "string",
          },
          {
            internalType: "bool",
            name: "userCompleted",
            type: "bool",
          },
          {
            internalType: "enum OrderProcessor.OrderStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "enum OrderProcessor.OrderType",
            name: "orderType",
            type: "uint8",
          },
          {
            components: [
              {
                internalType: "enum OrderProcessor.Entity",
                name: "raisedBy",
                type: "uint8",
              },
              {
                internalType: "enum OrderProcessor.DisputeStatus",
                name: "status",
                type: "uint8",
              },
              {
                internalType: "uint256",
                name: "redactTransId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "accountNumber",
                type: "uint256",
              },
            ],
            internalType: "struct OrderProcessor.Dispute",
            name: "disputeInfo",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct OrderProcessor.Order",
        name: "_order",
        type: "tuple",
      },
    ],
    name: "DisputeTransIdSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "version",
        type: "uint64",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "merchant",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fiatAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "placedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "completedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "userCompletedTimestamp",
            type: "uint256",
          },
          {
            internalType: "address[]",
            name: "assignedMerchants",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "acceptedMerchant",
            type: "address",
          },
          {
            internalType: "address",
            name: "user",
            type: "address",
          },
          {
            internalType: "address",
            name: "recipientAddr",
            type: "address",
          },
          {
            internalType: "string",
            name: "pubkey",
            type: "string",
          },
          {
            internalType: "string",
            name: "encUpi",
            type: "string",
          },
          {
            internalType: "bool",
            name: "userCompleted",
            type: "bool",
          },
          {
            internalType: "enum OrderProcessor.OrderStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "enum OrderProcessor.OrderType",
            name: "orderType",
            type: "uint8",
          },
          {
            components: [
              {
                internalType: "enum OrderProcessor.Entity",
                name: "raisedBy",
                type: "uint8",
              },
              {
                internalType: "enum OrderProcessor.DisputeStatus",
                name: "status",
                type: "uint8",
              },
              {
                internalType: "uint256",
                name: "redactTransId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "accountNumber",
                type: "uint256",
              },
            ],
            internalType: "struct OrderProcessor.Dispute",
            name: "disputeInfo",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct OrderProcessor.Order",
        name: "_order",
        type: "tuple",
      },
    ],
    name: "MerchantAssignedNewOrder",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "merchant",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fiatAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "placedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "completedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "userCompletedTimestamp",
            type: "uint256",
          },
          {
            internalType: "address[]",
            name: "assignedMerchants",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "acceptedMerchant",
            type: "address",
          },
          {
            internalType: "address",
            name: "user",
            type: "address",
          },
          {
            internalType: "address",
            name: "recipientAddr",
            type: "address",
          },
          {
            internalType: "string",
            name: "pubkey",
            type: "string",
          },
          {
            internalType: "string",
            name: "encUpi",
            type: "string",
          },
          {
            internalType: "bool",
            name: "userCompleted",
            type: "bool",
          },
          {
            internalType: "enum OrderProcessor.OrderStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "enum OrderProcessor.OrderType",
            name: "orderType",
            type: "uint8",
          },
          {
            components: [
              {
                internalType: "enum OrderProcessor.Entity",
                name: "raisedBy",
                type: "uint8",
              },
              {
                internalType: "enum OrderProcessor.DisputeStatus",
                name: "status",
                type: "uint8",
              },
              {
                internalType: "uint256",
                name: "redactTransId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "accountNumber",
                type: "uint256",
              },
            ],
            internalType: "struct OrderProcessor.Dispute",
            name: "disputeInfo",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct OrderProcessor.Order",
        name: "_order",
        type: "tuple",
      },
    ],
    name: "MerchantReAssignedNewOrder",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "merchant",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "pubKey",
        type: "string",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fiatAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "placedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "completedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "userCompletedTimestamp",
            type: "uint256",
          },
          {
            internalType: "address[]",
            name: "assignedMerchants",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "acceptedMerchant",
            type: "address",
          },
          {
            internalType: "address",
            name: "user",
            type: "address",
          },
          {
            internalType: "address",
            name: "recipientAddr",
            type: "address",
          },
          {
            internalType: "string",
            name: "pubkey",
            type: "string",
          },
          {
            internalType: "string",
            name: "encUpi",
            type: "string",
          },
          {
            internalType: "bool",
            name: "userCompleted",
            type: "bool",
          },
          {
            internalType: "enum OrderProcessor.OrderStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "enum OrderProcessor.OrderType",
            name: "orderType",
            type: "uint8",
          },
          {
            components: [
              {
                internalType: "enum OrderProcessor.Entity",
                name: "raisedBy",
                type: "uint8",
              },
              {
                internalType: "enum OrderProcessor.DisputeStatus",
                name: "status",
                type: "uint8",
              },
              {
                internalType: "uint256",
                name: "redactTransId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "accountNumber",
                type: "uint256",
              },
            ],
            internalType: "struct OrderProcessor.Dispute",
            name: "disputeInfo",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct OrderProcessor.Order",
        name: "_order",
        type: "tuple",
      },
    ],
    name: "OrderAccepted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "completedTimestamp",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fiatAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "placedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "completedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "userCompletedTimestamp",
            type: "uint256",
          },
          {
            internalType: "address[]",
            name: "assignedMerchants",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "acceptedMerchant",
            type: "address",
          },
          {
            internalType: "address",
            name: "user",
            type: "address",
          },
          {
            internalType: "address",
            name: "recipientAddr",
            type: "address",
          },
          {
            internalType: "string",
            name: "pubkey",
            type: "string",
          },
          {
            internalType: "string",
            name: "encUpi",
            type: "string",
          },
          {
            internalType: "bool",
            name: "userCompleted",
            type: "bool",
          },
          {
            internalType: "enum OrderProcessor.OrderStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "enum OrderProcessor.OrderType",
            name: "orderType",
            type: "uint8",
          },
          {
            components: [
              {
                internalType: "enum OrderProcessor.Entity",
                name: "raisedBy",
                type: "uint8",
              },
              {
                internalType: "enum OrderProcessor.DisputeStatus",
                name: "status",
                type: "uint8",
              },
              {
                internalType: "uint256",
                name: "redactTransId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "accountNumber",
                type: "uint256",
              },
            ],
            internalType: "struct OrderProcessor.Dispute",
            name: "disputeInfo",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct OrderProcessor.Order",
        name: "_order",
        type: "tuple",
      },
    ],
    name: "OrderCompleted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "by",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fiatAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "placedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "completedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "userCompletedTimestamp",
            type: "uint256",
          },
          {
            internalType: "address[]",
            name: "assignedMerchants",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "acceptedMerchant",
            type: "address",
          },
          {
            internalType: "address",
            name: "user",
            type: "address",
          },
          {
            internalType: "address",
            name: "recipientAddr",
            type: "address",
          },
          {
            internalType: "string",
            name: "pubkey",
            type: "string",
          },
          {
            internalType: "string",
            name: "encUpi",
            type: "string",
          },
          {
            internalType: "bool",
            name: "userCompleted",
            type: "bool",
          },
          {
            internalType: "enum OrderProcessor.OrderStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "enum OrderProcessor.OrderType",
            name: "orderType",
            type: "uint8",
          },
          {
            components: [
              {
                internalType: "enum OrderProcessor.Entity",
                name: "raisedBy",
                type: "uint8",
              },
              {
                internalType: "enum OrderProcessor.DisputeStatus",
                name: "status",
                type: "uint8",
              },
              {
                internalType: "uint256",
                name: "redactTransId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "accountNumber",
                type: "uint256",
              },
            ],
            internalType: "struct OrderProcessor.Dispute",
            name: "disputeInfo",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct OrderProcessor.Order",
        name: "_order",
        type: "tuple",
      },
    ],
    name: "OrderDispute",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "merchant",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "enum OrderProcessor.OrderType",
        name: "orderType",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "placedTimestamp",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fiatAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "placedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "completedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "userCompletedTimestamp",
            type: "uint256",
          },
          {
            internalType: "address[]",
            name: "assignedMerchants",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "acceptedMerchant",
            type: "address",
          },
          {
            internalType: "address",
            name: "user",
            type: "address",
          },
          {
            internalType: "address",
            name: "recipientAddr",
            type: "address",
          },
          {
            internalType: "string",
            name: "pubkey",
            type: "string",
          },
          {
            internalType: "string",
            name: "encUpi",
            type: "string",
          },
          {
            internalType: "bool",
            name: "userCompleted",
            type: "bool",
          },
          {
            internalType: "enum OrderProcessor.OrderStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "enum OrderProcessor.OrderType",
            name: "orderType",
            type: "uint8",
          },
          {
            components: [
              {
                internalType: "enum OrderProcessor.Entity",
                name: "raisedBy",
                type: "uint8",
              },
              {
                internalType: "enum OrderProcessor.DisputeStatus",
                name: "status",
                type: "uint8",
              },
              {
                internalType: "uint256",
                name: "redactTransId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "accountNumber",
                type: "uint256",
              },
            ],
            internalType: "struct OrderProcessor.Dispute",
            name: "disputeInfo",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct OrderProcessor.Order",
        name: "_order",
        type: "tuple",
      },
    ],
    name: "OrderPlaced",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fiatAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "placedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "completedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "userCompletedTimestamp",
            type: "uint256",
          },
          {
            internalType: "address[]",
            name: "assignedMerchants",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "acceptedMerchant",
            type: "address",
          },
          {
            internalType: "address",
            name: "user",
            type: "address",
          },
          {
            internalType: "address",
            name: "recipientAddr",
            type: "address",
          },
          {
            internalType: "string",
            name: "pubkey",
            type: "string",
          },
          {
            internalType: "string",
            name: "encUpi",
            type: "string",
          },
          {
            internalType: "bool",
            name: "userCompleted",
            type: "bool",
          },
          {
            internalType: "enum OrderProcessor.OrderStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "enum OrderProcessor.OrderType",
            name: "orderType",
            type: "uint8",
          },
          {
            components: [
              {
                internalType: "enum OrderProcessor.Entity",
                name: "raisedBy",
                type: "uint8",
              },
              {
                internalType: "enum OrderProcessor.DisputeStatus",
                name: "status",
                type: "uint8",
              },
              {
                internalType: "uint256",
                name: "redactTransId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "accountNumber",
                type: "uint256",
              },
            ],
            internalType: "struct OrderProcessor.Dispute",
            name: "disputeInfo",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct OrderProcessor.Order",
        name: "_order",
        type: "tuple",
      },
    ],
    name: "SellOrderUpiSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "completedTimestamp",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fiatAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "placedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "completedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "userCompletedTimestamp",
            type: "uint256",
          },
          {
            internalType: "address[]",
            name: "assignedMerchants",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "acceptedMerchant",
            type: "address",
          },
          {
            internalType: "address",
            name: "user",
            type: "address",
          },
          {
            internalType: "address",
            name: "recipientAddr",
            type: "address",
          },
          {
            internalType: "string",
            name: "pubkey",
            type: "string",
          },
          {
            internalType: "string",
            name: "encUpi",
            type: "string",
          },
          {
            internalType: "bool",
            name: "userCompleted",
            type: "bool",
          },
          {
            internalType: "enum OrderProcessor.OrderStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "enum OrderProcessor.OrderType",
            name: "orderType",
            type: "uint8",
          },
          {
            components: [
              {
                internalType: "enum OrderProcessor.Entity",
                name: "raisedBy",
                type: "uint8",
              },
              {
                internalType: "enum OrderProcessor.DisputeStatus",
                name: "status",
                type: "uint8",
              },
              {
                internalType: "uint256",
                name: "redactTransId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "accountNumber",
                type: "uint256",
              },
            ],
            internalType: "struct OrderProcessor.Dispute",
            name: "disputeInfo",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct OrderProcessor.Order",
        name: "_order",
        type: "tuple",
      },
    ],
    name: "SellOrderUserCompleted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    inputs: [],
    name: "UPGRADE_INTERFACE_VERSION",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_orderId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "_userEncUpi",
        type: "string",
      },
      {
        internalType: "string",
        name: "_pubKey",
        type: "string",
      },
    ],
    name: "acceptOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_orderId",
        type: "uint256",
      },
    ],
    name: "adminSettleDispute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_orderId",
        type: "uint256",
      },
    ],
    name: "assignMerchants",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_orderId",
        type: "uint256",
      },
    ],
    name: "cancelOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_orderId",
        type: "uint256",
      },
    ],
    name: "completeOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "currency",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "dailyBuyOrderLimit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "dailyBuyOrders",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "dailySellOrderLimit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "dailySellOrders",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "exchangeConfig",
    outputs: [
      {
        internalType: "contract IP2pxConfig",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "exchangeFiatBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "failSafe",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_merchant",
        type: "address",
      },
    ],
    name: "fetchMerchantAcceptedOrders",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fiatAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "placedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "completedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "userCompletedTimestamp",
            type: "uint256",
          },
          {
            internalType: "address[]",
            name: "assignedMerchants",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "acceptedMerchant",
            type: "address",
          },
          {
            internalType: "address",
            name: "user",
            type: "address",
          },
          {
            internalType: "address",
            name: "recipientAddr",
            type: "address",
          },
          {
            internalType: "string",
            name: "pubkey",
            type: "string",
          },
          {
            internalType: "string",
            name: "encUpi",
            type: "string",
          },
          {
            internalType: "bool",
            name: "userCompleted",
            type: "bool",
          },
          {
            internalType: "enum OrderProcessor.OrderStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "enum OrderProcessor.OrderType",
            name: "orderType",
            type: "uint8",
          },
          {
            components: [
              {
                internalType: "enum OrderProcessor.Entity",
                name: "raisedBy",
                type: "uint8",
              },
              {
                internalType: "enum OrderProcessor.DisputeStatus",
                name: "status",
                type: "uint8",
              },
              {
                internalType: "uint256",
                name: "redactTransId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "accountNumber",
                type: "uint256",
              },
            ],
            internalType: "struct OrderProcessor.Dispute",
            name: "disputeInfo",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
        ],
        internalType: "struct OrderProcessor.Order[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_merchant",
        type: "address",
      },
    ],
    name: "fetchMerchantAssignedOrders",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fiatAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "placedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "completedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "userCompletedTimestamp",
            type: "uint256",
          },
          {
            internalType: "address[]",
            name: "assignedMerchants",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "acceptedMerchant",
            type: "address",
          },
          {
            internalType: "address",
            name: "user",
            type: "address",
          },
          {
            internalType: "address",
            name: "recipientAddr",
            type: "address",
          },
          {
            internalType: "string",
            name: "pubkey",
            type: "string",
          },
          {
            internalType: "string",
            name: "encUpi",
            type: "string",
          },
          {
            internalType: "bool",
            name: "userCompleted",
            type: "bool",
          },
          {
            internalType: "enum OrderProcessor.OrderStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "enum OrderProcessor.OrderType",
            name: "orderType",
            type: "uint8",
          },
          {
            components: [
              {
                internalType: "enum OrderProcessor.Entity",
                name: "raisedBy",
                type: "uint8",
              },
              {
                internalType: "enum OrderProcessor.DisputeStatus",
                name: "status",
                type: "uint8",
              },
              {
                internalType: "uint256",
                name: "redactTransId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "accountNumber",
                type: "uint256",
              },
            ],
            internalType: "struct OrderProcessor.Dispute",
            name: "disputeInfo",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
        ],
        internalType: "struct OrderProcessor.Order[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_usdt",
        type: "address",
      },
      {
        internalType: "address",
        name: "_exchangeConfig",
        type: "address",
      },
      {
        internalType: "address",
        name: "_merchantRegistry",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "merchantAcceptedOrders",
    outputs: [
      {
        internalType: "uint256",
        name: "numOrders",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "merchantAssignedOrders",
    outputs: [
      {
        internalType: "uint256",
        name: "numOrders",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "merchantRegistry",
    outputs: [
      {
        internalType: "contract IMerchantRegistry",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "monthlyBuyOrderLimit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "monthlyBuyOrders",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "orderAssignedMerchants",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "orderExpiry",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "orders",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "fiatAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "placedTimestamp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "completedTimestamp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "userCompletedTimestamp",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "acceptedMerchant",
        type: "address",
      },
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipientAddr",
        type: "address",
      },
      {
        internalType: "string",
        name: "pubkey",
        type: "string",
      },
      {
        internalType: "string",
        name: "encUpi",
        type: "string",
      },
      {
        internalType: "bool",
        name: "userCompleted",
        type: "bool",
      },
      {
        internalType: "enum OrderProcessor.OrderStatus",
        name: "status",
        type: "uint8",
      },
      {
        internalType: "enum OrderProcessor.OrderType",
        name: "orderType",
        type: "uint8",
      },
      {
        components: [
          {
            internalType: "enum OrderProcessor.Entity",
            name: "raisedBy",
            type: "uint8",
          },
          {
            internalType: "enum OrderProcessor.DisputeStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "redactTransId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "accountNumber",
            type: "uint256",
          },
        ],
        internalType: "struct OrderProcessor.Dispute",
        name: "disputeInfo",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_orderId",
        type: "uint256",
      },
    ],
    name: "paidBuyOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_pubKey",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_recipientAddr",
        type: "address",
      },
      {
        internalType: "enum OrderProcessor.OrderType",
        name: "_orderType",
        type: "uint8",
      },
      {
        internalType: "string",
        name: "_userUpi",
        type: "string",
      },
    ],
    name: "placeOrder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_orderId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "redactTransId",
        type: "uint256",
      },
    ],
    name: "raiseDispute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "reduceExchangeFiatBalance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "merchant",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "releaseMerchantFunds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "releaseReveneShare",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "reputationManager",
    outputs: [
      {
        internalType: "contract IReputationManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "rpPerUsdtLimit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_orderId",
        type: "uint256",
      },
    ],
    name: "sellOrderUserCompleted",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_orderId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "redactTransId",
        type: "uint256",
      },
    ],
    name: "setDisputeTransId",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "setReputationManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_orderId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "_userEncUpi",
        type: "string",
      },
    ],
    name: "setSellOrderUpi",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_orderId",
        type: "uint256",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "string",
                name: "provider",
                type: "string",
              },
              {
                internalType: "string",
                name: "parameters",
                type: "string",
              },
              {
                internalType: "string",
                name: "context",
                type: "string",
              },
            ],
            internalType: "struct IReclaimSDK.ClaimInfo",
            name: "claimInfo",
            type: "tuple",
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: "bytes32",
                    name: "identifier",
                    type: "bytes32",
                  },
                  {
                    internalType: "address",
                    name: "owner",
                    type: "address",
                  },
                  {
                    internalType: "uint32",
                    name: "timestampS",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "epoch",
                    type: "uint32",
                  },
                ],
                internalType: "struct IReclaimSDK.CompleteClaimData",
                name: "claim",
                type: "tuple",
              },
              {
                internalType: "bytes[]",
                name: "signatures",
                type: "bytes[]",
              },
            ],
            internalType: "struct IReclaimSDK.SignedClaim",
            name: "signedClaim",
            type: "tuple",
          },
        ],
        internalType: "struct IReclaimSDK.Proof",
        name: "proof",
        type: "tuple",
      },
    ],
    name: "settleDispute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newLimit",
        type: "uint256",
      },
    ],
    name: "updateRpPerUsdtLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "usdt",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "userOrdersArr",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fiatAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "placedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "completedTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "userCompletedTimestamp",
            type: "uint256",
          },
          {
            internalType: "address[]",
            name: "assignedMerchants",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "acceptedMerchant",
            type: "address",
          },
          {
            internalType: "address",
            name: "user",
            type: "address",
          },
          {
            internalType: "address",
            name: "recipientAddr",
            type: "address",
          },
          {
            internalType: "string",
            name: "pubkey",
            type: "string",
          },
          {
            internalType: "string",
            name: "encUpi",
            type: "string",
          },
          {
            internalType: "bool",
            name: "userCompleted",
            type: "bool",
          },
          {
            internalType: "enum OrderProcessor.OrderStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "enum OrderProcessor.OrderType",
            name: "orderType",
            type: "uint8",
          },
          {
            components: [
              {
                internalType: "enum OrderProcessor.Entity",
                name: "raisedBy",
                type: "uint8",
              },
              {
                internalType: "enum OrderProcessor.DisputeStatus",
                name: "status",
                type: "uint8",
              },
              {
                internalType: "uint256",
                name: "redactTransId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "accountNumber",
                type: "uint256",
              },
            ],
            internalType: "struct OrderProcessor.Dispute",
            name: "disputeInfo",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
        ],
        internalType: "struct OrderProcessor.Order[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "userTxLimit",
    outputs: [
      {
        internalType: "uint256",
        name: "limit",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "users",
    outputs: [
      {
        internalType: "uint256",
        name: "numOrdersPlaced",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "numOrdersCompleted",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "usdtVolume",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];
export const configAbi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "AddressEmptyCode",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "ERC1967InvalidImplementation",
    type: "error",
  },
  {
    inputs: [],
    name: "ERC1967NonPayable",
    type: "error",
  },
  {
    inputs: [],
    name: "FailedInnerCall",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidInitialization",
    type: "error",
  },
  {
    inputs: [],
    name: "NotInitializing",
    type: "error",
  },
  {
    inputs: [],
    name: "UUPSUnauthorizedCallContext",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "slot",
        type: "bytes32",
      },
    ],
    name: "UUPSUnsupportedProxiableUUID",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "admin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "currency",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "currExchangeINRPrice",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "updatedExchangeINRPrice",
        type: "uint256",
      },
    ],
    name: "BuyPriceUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "version",
        type: "uint64",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "admin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "currLimit",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "updatedLimit",
        type: "uint256",
      },
    ],
    name: "LimitPerTxUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "admin",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "buyMin",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "buyMax",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "sellMin",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "sellMax",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct P2pxConfig.ProcessingTimeSecs",
        name: "currTime",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "buyMin",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "buyMax",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "sellMin",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "sellMax",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct P2pxConfig.ProcessingTimeSecs",
        name: "updatedTime",
        type: "tuple",
      },
    ],
    name: "ProcessingTimeUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "admin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "currency",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "currExchangeINRPrice",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "updatedExchangeINRPrice",
        type: "uint256",
      },
    ],
    name: "SellPriceUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "admin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "currStatus",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "updatedStatus",
        type: "bool",
      },
    ],
    name: "UpdatedExchangeStatus",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    inputs: [],
    name: "UPGRADE_INTERFACE_VERSION",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "admins",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "exchangeStatus",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_admins",
        type: "address[]",
      },
      {
        internalType: "bytes32",
        name: "_currency",
        type: "bytes32",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "buyPrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "sellPrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "buyPriceOffset",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "baseSpread",
            type: "uint256",
          },
        ],
        internalType: "struct P2pxConfig.PriceConfig",
        name: "_priceConfig",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "buyMin",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "buyMax",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "sellMin",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "sellMax",
            type: "uint256",
          },
        ],
        internalType: "struct P2pxConfig.ProcessingTimeSecs",
        name: "_processingTime",
        type: "tuple",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_admin",
        type: "address",
      },
    ],
    name: "isAdmin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_admin",
        type: "address",
      },
    ],
    name: "isSuperAdmin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "priceConfig",
    outputs: [
      {
        internalType: "uint256",
        name: "buyPrice",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "sellPrice",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "buyPriceOffset",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "baseSpread",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "processingTime",
    outputs: [
      {
        internalType: "uint256",
        name: "buyMin",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "buyMax",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "sellMin",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "sellMax",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_currency",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "_spread",
        type: "uint256",
      },
    ],
    name: "setBaseSpread",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_currency",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "_buyPrice",
        type: "uint256",
      },
    ],
    name: "setBuyPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_currency",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "_buyPriceOffset",
        type: "uint256",
      },
    ],
    name: "setBuyPriceOffset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_currency",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "_sellPrice",
        type: "uint256",
      },
    ],
    name: "setSellPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "superAdmins",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "toggleExchangeStatus",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_admin",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_status",
        type: "bool",
      },
    ],
    name: "updateAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "buyMin",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "buyMax",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "sellMin",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "sellMax",
            type: "uint256",
          },
        ],
        internalType: "struct P2pxConfig.ProcessingTimeSecs",
        name: "_processingTime",
        type: "tuple",
      },
    ],
    name: "updateProcessingTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
];
